import React from "react"
import {
    Panel,
    Text,
    IconAccount,
    IconKey,
    IconLogout,
    IconProfileBilling
} from "dash-styled"
import { useDispatch } from "react-redux"
import { getEmail } from "../../../../../Helpers/Functions/Selectors/auth"
import { openModal } from "../../../../../Actions/Client/ModalActions"
import { ModalViewName } from "../../../../../Models/Client/Modal"
import { userLogout } from "../../../../../Actions/Auth/AuthActions"
import { AccountMenuItem } from "./AccountMenuItem"
import { useAppState } from "../../../../../Hooks/useReduxState"
import { OrgChooser } from "../../../../Common/OrgChooser/OrgChooser"

interface AccountMenuProps {
    className?: string
    orgUsername: string
    compact?: boolean
}

export function AccountMenu({
    orgUsername,
    className,
    compact
}: AccountMenuProps) {
    const email = useAppState(getEmail)
    const dispatch = useDispatch()
    const handleClickApiKeys = () => dispatch(openModal(ModalViewName.keys))
    const handleClickBilling = () => dispatch(openModal(ModalViewName.billing))
    const handleClickLogout = () => dispatch(userLogout(false))

    return (
        <Panel className={className} size="lg" noPadding={true}>
            <Text className="text-gray-600 flex items-center p-5 m-0">
                <IconAccount className="mr-2" />
                {email}
            </Text>
            <OrgChooser
                selectedOrgUsername={orgUsername}
                size="sm"
                label="Dashboard context"
                className="px-4 pb-4 pt-1 border-t border-b border-solid border-gray-300 text-left"
            />
            <ul className="list-none m-0 p-0">
                {!compact && (
                    <>
                        <li>
                            <AccountMenuItem onClick={handleClickApiKeys}>
                                <IconKey
                                    className="mr-3 flex-shrink-0"
                                    size="lg"
                                />
                                API Keys
                            </AccountMenuItem>
                        </li>
                        <li>
                            <AccountMenuItem onClick={handleClickBilling}>
                                <IconProfileBilling
                                    className="mr-3 flex-shrink-0"
                                    size="lg"
                                />
                                Billing
                            </AccountMenuItem>
                        </li>
                    </>
                )}
                <li>
                    <AccountMenuItem
                        onClick={handleClickLogout}
                        testId="user-logout"
                    >
                        <IconLogout className="mr-3 flex-shrink-0" size="lg" />
                        Log Out
                    </AccountMenuItem>
                </li>
            </ul>
        </Panel>
    )
}
